module.exports = __webpack_public_path__ + "static/media/515.6ec0dbdf.jpg";